import { ReactComponent as HoofIcon } from 'assets/hoof-icon.svg'
import { PositionHoof } from 'models'
import { useMemo } from 'react'
import { COLORS } from 'styles/colors'
interface IHoofPositionsSchemaProps {
	placement: PositionHoof
	active: boolean
	count: number
}

const cellPositions: Record<PositionHoof, [number, number]> = {
	[PositionHoof.Front_Left]: [1, 1],
	[PositionHoof.Front_Right]: [1, 2],
	[PositionHoof.Rear_Left]: [2, 1],
	[PositionHoof.Rear_Right]: [2, 2],
	[PositionHoof.All]: [0, 0],
}

export const HoofPositionsSchema = ({
	placement,
	active,
	count,
}: IHoofPositionsSchemaProps) => {
	const iconPos = cellPositions[placement]
	const countIsZero = useMemo(() => count === 0, [count])

	return (
		<div
			style={{
				display: 'grid',
				gridTemplateColumns: '1fr 1fr',
				gridTemplateRows: '1fr 1fr',
				gap: '8px',
				width: '52px',
				height: '52px',
			}}
		>
			{[1, 2].map(row =>
				[1, 2].map(col => (
					<div
						key={`${row}-${col}`}
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							width: '100%',
							height: '100%',
						}}
					>
						{iconPos[0] === row && iconPos[1] === col ? (
							<HoofIcon
								stroke={
									active ? '#fff' : countIsZero ? COLORS.icon : COLORS.health
								}
								fill={countIsZero || active ? '#fff' : COLORS.health}
								style={{ width: '100%', height: '100%' }}
							/>
						) : (
							<span
								style={{
									width: '12px',
									height: '12px',
									borderRadius: '50%',
									backgroundColor: active ? '#fff' : COLORS.icon,
								}}
							/>
						)}
					</div>
				)),
			)}
		</div>
	)
}
